import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import FadeInSection from "../components/FadeInSection";

declare global {
    interface Window {
        grecaptcha: any;
    }
}

const ContactForm = () => {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        club_name: "",
        email: "",
        telephone: "",
        message: "",
        to_name: "Grassroots360 Team",
    });
    const [isSent, setIsSent] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!window.grecaptcha) {
            console.error("reCAPTCHA is not loaded");
            return;
        }

        // Execute reCAPTCHA before sending the form
        window.grecaptcha.enterprise.execute("6LeHrJ8qAAAAAHVZqFtPJvJxTrgwfbPlsyeqgPpk", { action: "submit" })
            .then((token: string) => {
                console.log("reCAPTCHA token:", token);

                const formWithToken = { ...formData, "g-recaptcha-response": token };

                emailjs.send(
                    "service_ausb2km",
                    "template_ey90w3f",
                    formWithToken,
                    "81J8oXgS-t2Y8vbL2"
                ).then(
                    (response) => {
                        console.log("SUCCESS!", response.status, response.text);
                        setIsSent(true);
                    },
                    (error) => {
                        console.error("FAILED...", error);
                    }
                );
            })
            .catch((error: any) => {
                console.error("reCAPTCHA failed", error);
            });
    };

    return (
        <FadeInSection>
            <div className="container">
                <div className="col-xs-12">
                    <div className="contact-form-content">
                        <h3>Contact Us</h3>
                        <p>We aim to get back to your message within 1 to 2 days. We will contact you once we have read your message.</p>

                        <form onSubmit={handleSubmit}>
                            <div>
                                <label>First Name:</label>
                                <input
                                    type="text"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                />
                            </div>
                            <div>
                                <label>Last Name:</label>
                                <input
                                    type="text"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                />
                            </div>
                            <div>
                                <label>Club Name:</label>
                                <input
                                    type="text"
                                    name="club_name"
                                    value={formData.club_name}
                                    onChange={handleChange}
                                    placeholder="Club Name"
                                    required
                                />
                            </div>
                            <div>
                                <label>Email:</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Your Email"
                                    required
                                />
                            </div>
                            <div>
                                <label>Telephone:</label>
                                <input
                                    type="tel"
                                    name="telephone"
                                    value={formData.telephone}
                                    onChange={handleChange}
                                    placeholder="Your Phone Number"
                                    required
                                />
                            </div>
                            <div>
                                <label>Message:</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Your Message"
                                    required
                                />
                            </div>
                            <button type="submit">
                                <span className="material-symbols-outlined">send</span> Send
                            </button>

                            {isSent && (
                                <p className="success-message">
                                    <span className="material-symbols-outlined">mark_email_read</span>
                                    Thank you! Your message has been sent.
                                </p>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </FadeInSection>
    );
};

export default ContactForm;
